import React from 'react';
import { Grid as GridIcon } from '@finect/tabular-icons/grid';
import { List } from '@finect/tabular-icons/list';
import { Inner } from './partials';
var viewModeIcons = {
  table: GridIcon,
  grid: List
};
export var ViewToggle = function ViewToggle(_ref) {
  var view = _ref.view,
    _onClick = _ref.onClick;
  var Icon = viewModeIcons[view];
  return React.createElement(Inner, {
    onClick: function onClick() {
      return _onClick(view === 'table' ? 'grid' : 'table');
    },
    title: "Cambiar vista"
  }, React.createElement(Icon, null));
};
export default ViewToggle;